import Entities from "./shared/Entities";

export default class ScrollTiles {
  constructor() {
    this.entities = new Entities("ScrollTiles", "[data-scroll-tiles]", ScrollTiles.initSingle, ScrollTiles.destroySingle);
  }

  static initSingle(containerEl) {
    const title = containerEl.querySelector("[data-title]");
    const tiles = containerEl.querySelectorAll("[data-tile]");
    const bottomBlock = containerEl.querySelector("[data-bottom-block]");
    const isDesktop = () => window.innerWidth >= 1280;
    const isMobile = () => window.innerWidth <= 1024;

    const state = {
      el: containerEl,
      title,
      tiles,
      bottomBlock,
      raf: null,
    };
    const clamp = (v, min, max) => Math.min(Math.max(v, min), max);
    const lerp = (a, b, t) => a + (b - a) * t;
    const smoothstep = (t) => t * t * (3 - 2 * t);

    const getSectionProgress = () => {
      const rect = containerEl.getBoundingClientRect();
      const vh = window.innerHeight;

      let p = 1 - rect.top / vh;
      return p;
    };

    const getElementProgress = (el) => {
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;

      return clamp((vh - rect.top) / (vh * 0.6), 0, 1);
    };

    const render = () => {
      const rawP = getSectionProgress();
      const sectionP = smoothstep(clamp(rawP, 0, 1));
      const desktop = isDesktop();
      const mobile = isMobile();

      if (mobile) return;

      const phase1End = 0.7;

      const tileStart = 0.3;
      const tileEnd = 1.3;

      const tileP = clamp((rawP - tileStart) / (tileEnd - tileStart), 0, 1);

      const p1 = clamp(tileP / phase1End, 0, 1);
      const p2 = clamp((tileP - phase1End) / (1 - phase1End), 0, 1);

      if (title) {
        const opacity = lerp(1, 0, sectionP);
        const scale = lerp(1, 0.85, sectionP);
        const y = lerp(0, -100, sectionP);

        title.style.opacity = opacity;
        title.style.transform = `translateY(${y}px) scale(${scale})`;
      }

      tiles.forEach((tile, i) => {
        const p1e = smoothstep(p1);
        const p2e = smoothstep(p2);

        const liftMap = [-150, -90, -150, -100];
        const liftTarget = liftMap[i] || -50;
        const liftUp = lerp(0, liftTarget, p1e);

        const dropMapDesktop = [800, 340, 800, 240];
        const dropMapTablet = [700, 340, 700, 240];
        const dropMap = desktop ? dropMapDesktop : dropMapTablet;
        const dropTarget = dropMap[i] || 40;
        const dropDown = lerp(liftTarget, dropTarget, p2e);

        const spreadMapDesktop = [-120, -220, 340, -60];
        const spreadMapTablet = [-80, -220, 260, -60];
        const spreadMap = desktop ? spreadMapDesktop : spreadMapTablet;
        const spread = lerp(0, spreadMap[i] || 0, p2e);

        const scaleMap = [0.5, 0.6, 0.6, 0.75];
        const targetScale = scaleMap[i] || 0.85;

        const rotateStartMap = [1, -3, 3, -1];
        const rotateEndMap = [0, 5, -3, 0];

        const startRotate = rotateStartMap[i] || 0;
        const endRotate = rotateEndMap[i] || 0;

        const rotate = lerp(startRotate, endRotate, p2e);

        const scale = lerp(1, targetScale, p2e);

        const y = lerp(liftUp, dropDown, p2e);

        tile.style.transform = `
    translateY(${y}px)
    translateX(${spread}px)
    scale(${scale})
    rotate(${rotate}deg)
  `;
      });

      if (bottomBlock) {
        const bottomP = smoothstep(getElementProgress(bottomBlock));

        const opacity = lerp(0, 1, bottomP);
        const y = lerp(80, 0, bottomP);
        const scale = lerp(0.85, 1, bottomP);

        bottomBlock.style.opacity = opacity;
        bottomBlock.style.transform = `translateY(${y}px) scale(${scale})`;
      }

      state.raf = requestAnimationFrame(render);
    };

    render();

    window.addEventListener("resize", () => {
      render();
    })

    state.destroy = () => {
      cancelAnimationFrame(state.raf);
    };

    return state;
  }

  static destroySingle({ entityObj }) {
    entityObj?.destroy();
  }
}
